import styled from 'styled-components/macro';

export const DownloadLink = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.blue};
  cursor: pointer;
  white-space: nowrap;
  span {
    margin-left: 5px;
    &:hover {
      text-decoration: underline;
    }
  }
`;
